class InterActiveButtonSVG {
  constructor() {
    const buttons = document.querySelectorAll('.lc-interactive-svg-button');
    const popups = [...document.querySelectorAll('.lc-interactive-svg-button-popup')];
    buttons.forEach(b => {
      const bIdentifier = b.querySelector('.lc-interactive-svg-button__identifier');
      const bPopup = popups.find(p => {
        const pIdentifier = p.querySelector('.lc-interactive-svg-button-popup__identifier');
        if (pIdentifier && bIdentifier && pIdentifier.innerText === bIdentifier.innerText) {
          return true;
        }

        return false;
      });
      b.addEventListener('click', () => {
        console.log(bPopup);

        if (b.classList.contains('active')) {
          b.classList.remove('active');
          if (bPopup) bPopup.classList.remove('active')
        } else {

          buttons.forEach(bb => bb.classList.remove('active'));
          popups.forEach(p => p.classList.remove('active'));

          if (bPopup) {
            bPopup.classList.add('active');
            b.classList.add('active');
            bPopup.style.left = b.style.left;
            bPopup.style.top = b.style.top;
          }
        }
      })
    })
  }
}

export default InterActiveButtonSVG;